import React, { useEffect, useState } from 'react';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from '@chakra-ui/react';
import { useContext } from 'react';
import SessionContext from 'session/SessionContext';
import BirdLoader from 'components/birdloader/birdloader';

interface ResetPasswordProps {
  token: string;
}
export default function ResetEmail(props: ResetPasswordProps): JSX.Element {
  const session = useContext(SessionContext);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    async function resetEmail() {
      const r = await session.actions.resetEmail(props.token);
      if (r && !reset) {
        setReset(true);
      }
    }
    resetEmail();
  });

  return (
    <>
      {reset ? (
        <Alert
          status="success"
          variant="subtle"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          height="400px">
          <AlertIcon boxSize="40px" mr={0} />
          <AlertTitle mt={4} mb={1} fontSize="lg">
            Din e-post har återställts!
          </AlertTitle>
          <AlertDescription maxWidth="sm">
            Vi har återställt din e-post, och vi skickar även ett mail för
            återställning av ditt lösenord!
          </AlertDescription>
        </Alert>
      ) : (
        <BirdLoader />
      )}
    </>
  );
}
